import request from '@/util/server.js'

let origin = ''

const hostname = window.location.hostname

// 定义需要特殊处理的主机名映射
const hostMap = {
  '192.168.66.204': '47.101.146.129',
  '192.168.110.32': '47.101.146.129',
  'localhost': '47.101.146.129',  
  '127.0.0.1': '47.101.146.129',
  '220.168.222.114': '220.168.222.114',
  '47.101.146.129': '47.101.146.129',
  'xn--pbtr9xa.com': '220.168.222.114'
}

if (hostMap[hostname]) {
  // 使用当前页面的协议（HTTP或HTTPS）
  const protocol = window.location.protocol
  origin = `${protocol}//${hostMap[hostname]}`
} else {
  // 其他情况直接使用当前origin
  origin = window.location.origin
}

export const originUrl = origin

// 商家后台地址
let MerchantBackstage = ''
if (hostname.includes('xn--pbtr9xa.com')) {
  MerchantBackstage = `http://220.168.222.114:86/#/login`
} else {
  MerchantBackstage = `${originUrl}:86/#/login`
}

export const MerchantBackstageUrl = MerchantBackstage

let settledUrl = ''
if (hostname.includes('xn--pbtr9xa.com')) {
  settledUrl = `https://${hostname}/settled-merchant/#/`
} else {
  settledUrl = `${originUrl}:83/settled-merchant/#/`
}

export const settled = settledUrl // 商家入驻地址

// 获取首页导航栏分类
export function getCategory (params) {
  return request({
    url: '/classify/getFirstClassify',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/nav.js